import { NbMenuItem } from "@nebular/theme";

export interface AppMenuItem extends NbMenuItem {
  permissionKey?: string;
  reuse?: boolean;
  children?: AppMenuItem[];
}

const addReuseToAll = (items: AppMenuItem[]): AppMenuItem[] => {
  return items.map((item) => ({
    ...item,
    reuse: true,
    children: item.children ? addReuseToAll(item.children) : undefined,
  }));
};

export const MENU_ITEMS: AppMenuItem[] = addReuseToAll([
  // =====================================================
  // DASHBOARD
  // =====================================================
  {
    title: "Dashboard",
    icon: "grid",
    link: "/pages/dashboard",
    permissionKey: "dashboard",
    home: true,
  },
  {
    title: "Entities",
    icon: "briefcase",
    permissionKey: "entities",
    children: [
      {
        title: "Manage Entities",
        link: "/pages/admin/entities",
        permissionKey: "entities",
      },
    ],
  },
  // =====================================================
  // QUOTATIONS
  // =====================================================
  {
    title: "Quotations",
    permissionKey: "Quotation",
    icon: "file-text",
    children: [
      {
        title: "Create Quotation",
        icon: "plus-circle-outline",
        link: "/pages/quotation",
        queryParams: { formKey: "newquotation" },
        permissionKey: "newquotation",
      },
      {
        title: "Manage Quotations",
        icon: "plus-circle-outline",
        link: "/pages/quotation/manage-quotation",
        queryParams: { formKey: "managequotation" },
        permissionKey: "managequotation",
      },
    ],
  },

  // =====================================================
  // SHIPMENT OPERATIONS
  // =====================================================
  {
    title: "Shipment Operations",
    icon: "layers",
    permissionKey: "jobs",
    children: [
      {
        title: "New Import MBL",
        icon: "plus-circle-outline",
        link: "/pages/operations/import-mbl",
        queryParams: { formKey: "importmbl" },
        permissionKey: "importmbl",
      },
      {
        title: "New Export MBL",
        icon: "plus-circle-outline",
        link: "/pages/operations/export-mbl",
        queryParams: { formKey: "exportmbl" },
        permissionKey: "exportmbl",
      },
      {
        title: "New Export Booking",
        icon: "plus-circle-outline",
        link: "/pages/operations/dynamic-bookings",
        queryParams: { formKey: "newbookings" },
        permissionKey: "newbookings",
      },
      {
        title: "Manage MBL & HBL",
        icon: "plus-circle-outline",
        link: "/pages/operations/view-bls",
        queryParams: { formKey: "viewbls" },
        permissionKey: "viewbls",
      },
    ],
  },
  {
    title: "BL Templates",
    icon: "settings-2-outline",
    permissionKey: "bl-template",
    queryParams: { formKey: "bl-template" },
    link: "/pages/bl-template",
  },

  // =====================================================
  // BUSINESS PARTNERS
  // =====================================================


  // =====================================================
  // RECEIPTS
  // =====================================================
  {
    title: "Receipts",
    icon: "checkmark-circle-2",
    permissionKey: "receiving",
    children: [
      {
        title: "Invoice Receiving",
        icon: "plus-circle-outline",
        link: "/pages/accounts/invoicereceiving",
        permissionKey: "invoicereceiving",
      },
      {
        title: "Other Receiving",
        icon: "plus-circle-outline",
        link: "/pages/accounts/other-receiving",
        permissionKey: "otherreceiving",
      },
      {
        title: "Pay Back On Invoice",
        icon: "plus-circle-outline",
        link: "/pages/accounts/pay-back-on-invoice",
        permissionKey: "paybackoninvoice",
      },
      {
        title: "Receiving Vouchers",
        icon: "plus-circle-outline",
        link: "/pages/accounts/receiving-vouchers",
        permissionKey: "receivingvouchers",
      },
    ],
  },

  // =====================================================
  // PAYMENTS
  // =====================================================
  {
    title: "Payments",
    icon: "credit-card",
    permissionKey: "payments",
    children: [
      {
        title: "MBL Payments",
        icon: "plus-circle-outline",
        link: "/pages/accounts/mblpayment",
        permissionKey: "mblpayment",
      },
      {
        title: "Pay To Agent",
        icon: "plus-circle-outline",
        link: "/pages/accounts/pay-to-agents",
        permissionKey: "paytoagents",
      },
      {
        title: "Other Payments",
        icon: "plus-circle-outline",
        link: "/pages/accounts/other-payments",
        permissionKey: "otherpayments",
      },
      {
        title: "Payment Voucher",
        icon: "plus-circle-outline",
        link: "/pages/accounts/payment-voucher",
        permissionKey: "paymentvoucher",
      },
    ],
  },

  // =====================================================
  // CHEQUE MANAGEMENT
  // =====================================================
  {
    title: "Cheque Management",
    permissionKey: "Finance",
    icon: "credit-card-outline",
    children: [
      {
        title: "Print Cheque",
        icon: "printer-outline",
        link: "/pages/finance/print",
        queryParams: { formKey: "printcheque" },
        permissionKey: "finance",
      },
      {
        title: "Cheque Register",
        icon: "list-outline",
        link: "/pages/finance/register",
        queryParams: { formKey: "chequeregister" },
        permissionKey: "finance",
      },
      {
        title: "Cheque Templates",
        icon: "settings-2-outline",
        link: "/pages/finance/templates",
        queryParams: { formKey: "chequetemplates" },
        permissionKey: "finance",
      },
      {
        title: "Cheque Books",
        icon: "book-open-outline",
        link: "/pages/finance/books",
        queryParams: { formKey: "chequebooks" },
        permissionKey: "finance",
      },
    ],
  },

  // =====================================================
  // FINANCIAL MANAGEMENT
  // =====================================================
  {
    title: "Financial Management",
    icon: "pie-chart-outline",
    permissionKey: "accounts",
    children: [
      {
        title: "Chart of Accounts",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "chartofaccount" },
        permissionKey: "chartofaccount",
      },
      {
        title: "Bank & Cash Account",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "bankandcashaccounts" },
        permissionKey: "bankandcashaccounts",
      },
      {
        title: "Shipment Pay/Rec Heads",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "shipmentpayrechead" },
        permissionKey: "shipmentpayrechead",
      },
      {
        title: "Add JV",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "addJV" },
        permissionKey: "addJV",
      },
      {
        title: "Inter Bank Transfer",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "interbanktransfer" },
        permissionKey: "interbanktransfer",
      },
      {
        title: "Bank Reconcile",
        icon: "plus-circle-outline",
        link: "/pages/accounts/bankreconcile",
        permissionKey: "bankreconcile",
      },
      {
        title: "Month Locks",
        icon: "plus-circle-outline",
        link: "/pages/accounts/dynamic-form",
        queryParams: { form: "monthlock" },
        permissionKey: "monthlock",
      },

      // {
      //   title: "Manage JV Vouchers",
      //   icon: "plus-circle-outline",
      //   link: "/pages/accounts/dynamic-form",
      //   permissionKey: "manageJVvoucher",
      //   queryParams: { form: "manageJVvoucher" },
      // },
    ],
  },

  // =====================================================
  // FINANCIAL REPORTS
  // =====================================================
  {
    title: "Financial Reports",
    icon: "book-open",
    permissionKey: "accounts",
    children: [
      // ---------------------------------------------
      // CASH AND BANK REPORTS
      // ---------------------------------------------
      {
        title: "Bank & Cash Position",
        link: "/pages/accounts/bankandcashposition",
        permissionKey: "bankandcashposition",
        pathMatch: "full",
      },
      {
        title: "Daily Cash Report",
        link: "/pages/accounts/daliycashreport",
        permissionKey: "daliycashreport",
        pathMatch: "full",
      },
      {
        title: "PDC Report",
        link: "/pages/accounts/pdc-report",
        permissionKey: "pdcreport",
        pathMatch: "full",
      },
      {
        title: "Bank Reconciliation Report",
        link: "/pages/accounts/bankreconciliationreport",
        permissionKey: "bankreconciliationreport",
        pathMatch: "full",
      },

      // ---------------------------------------------
      // LEDGER AND JOURNAL REPORTS
      // ---------------------------------------------
      {
        title: "Ledger Report",
        link: "/pages/accounts/ledger-report-currency",
        pathMatch: "full",
        permissionKey: "ledgerreportcurrency",
      },

      // {
      //   title: "Ledger Report (Currency)",
      //   link: "/pages/accounts/ledger-report",
      //   pathMatch: "full",
      //   permissionKey: "ledgerreport",
      // },

      {
        title: "Receivable Ledger",
        link: "/pages/accounts/receivableledger",
        pathMatch: "full",
        permissionKey: "receivableledger",
      },
      {
        title: "General Journal",
        link: "/pages/accounts/generaljournal",
        permissionKey: "generaljournal",
        pathMatch: "full",
      },

      // ---------------------------------------------
      // RECEIVABLE AND LIABILITY REPORTS
      // ---------------------------------------------
      {
        title: "Receivable Report",
        link: "/pages/accounts/receivablereport",
        pathMatch: "full",
        permissionKey: "receivablereport",
      },
      {
        title: "Liability Report",
        link: "/pages/accounts/liabilityreport",
        pathMatch: "full",
        permissionKey: "liabilityreport",
      },
      {
        title: "Customer Security Deposit Report",
        link: "/pages/accounts/customer-security-deposit-report",
        queryParams: {
          formKey: "customer-security-deposit-report",
        },
        permissionKey: "customer-security-deposit-report",
        pathMatch: "full",
      },
      {
        title: "Line Security Deposit Report",
        link: "/pages/accounts/line-security-deposit-report",
        queryParams: {
          formKey: "line-security-deposit-report",
        },
        permissionKey: "line-security-deposit-report",
        pathMatch: "full",
      },

      // ---------------------------------------------
      // PROFIT AND PERFORMANCE REPORTS
      // ---------------------------------------------
      {
        title: "Revenue Report",
        link: "/pages/accounts/revenuereport",
        pathMatch: "full",
        permissionKey: "revenuereport",
      },
      {
        title: "Expense Report",
        link: "/pages/accounts/expensereport",
        permissionKey: "expensereport",
        pathMatch: "full",
      },
      {
        title: "Jobs P&L",
        link: "/pages/accounts/jobspl",
        permissionKey: "jobspl",
        pathMatch: "full",
      },
      {
        title: "Zoom P&L Jobs",
        link: "/pages/accounts/zoompljobs",
        pathMatch: "full",
        permissionKey: "zoompljobs",
      },

      // ---------------------------------------------
      // FINANCIAL STATEMENTS
      // ---------------------------------------------
      {
        title: "Trial Balance",
        link: "/pages/accounts/trialbalance",
        pathMatch: "full",
        permissionKey: "trialbalance",
      },
      {
        title: "Financial Statement",
        link: "/pages/accounts/financialstatement",
        permissionKey: "financialstatement",
        pathMatch: "full",
      },
    ],
  },

  // =====================================================
  // LEDGER MANAGEMENT
  // =====================================================
  {
    title: "Ledger Management",
    icon: "grid",
    permissionKey: "ledgermanagement",
    link: "/pages/accounts/ledger-management",
  },

  // =====================================================
  // SALES REPORTS
  // =====================================================
  {
    title: "Sales Reports",
    icon: "pie-chart-outline",
    permissionKey: "sales",
    children: [
      {
        title: "Sales Sheet",
        link: "/pages/sales/sales",
        permissionKey: "sales",
      },
    ],
  },

  // =====================================================
  // OPERATIONAL REPORTS
  // =====================================================
  {
    title: "Operational Reports",
    icon: "pie-chart-outline",
    permissionKey: "reports",
    children: [
      {
        title: "Master BL Report",
        icon: "plus-circle-outline",
        link: "/pages/reports/masterblreport",
        permissionKey: "masterblreport",
      },
      {
        title: "House BL Report",
        icon: "plus-circle-outline",
        link: "/pages/reports/house-bl-report",
        permissionKey: "houseblreport",
      },
      {
        title: "LCL Consolidation Report",
        icon: "plus-circle-outline",
        link: "/pages/reports/lcl-consolidation-report",
        permissionKey: "lclconsolidationreport",
      },
      {
        title: "Lines Vol. Moving Report",
        icon: "plus-circle-outline",
        link: "/pages/reports/linereport",
        permissionKey: "linereport",
      },
      {
        title: "Consignee Vol. Moving",
        icon: "plus-circle-outline",
        link: "/pages/reports/consignee-vol-moving",
        permissionKey: "consigneevolmoving",
      },
      {
        title: "Planning Demand Report",
        icon: "plus-circle-outline",
        link: "/pages/reports/planning-demand-report",
        permissionKey: "planningdemandreport",
      },
    ],
  },

  // =====================================================
  // HUMAN RESOURCES
  // =====================================================
  {
    title: "Human Resources",
    icon: "people",
    permissionKey: "hr",
    children: [
      {
        title: "Users",
        link: "/pages/hr/users",
        permissionKey: "users",
      },
      {
        title: "Companies",
        link: "/pages/hr/companies",
        permissionKey: "companies",
      },
      {
        title: "Attendance",
        link: "/pages/hr/attendance",
        permissionKey: "attendence",
        queryParams: { formKey: "attendence" },
      },
      {
        title: "Leaves",
        link: "/pages/hr/leaves",
        permissionKey: "leaves",
      },
      {
        title: "Holidays",
        link: "/pages/hr/holidays",
        permissionKey: "holidays",
      },
      {
        title: "Loan",
        link: "/pages/hr/loan",
        permissionKey: "loan",
      },
      {
        title: "Salary",
        link: "/pages/hr/sallary",
        permissionKey: "sallary",
      },
    ],
  },

  // =====================================================
  // BL TEMPLATES
  // =====================================================

  // =====================================================
  // SYSTEM POLICIES
  // =====================================================
  {
    title: "System Policies",
    icon: "settings-2-outline",
    permissionKey: "do-policy",
    queryParams: { formKey: "do-policy" },
    link: "/pages/do-policy",
  },

  {
    title: "SMTP Settings",
    icon: "email-outline",
    permissionKey: "smtpsettings",
    link: "/pages/smtp-settings",
  },


  // =====================================================
  // DISABLED MENU
  // =====================================================

  // {
  //   title: "Data Fetching",
  //   icon: "grid",
  //   permissionKey: "datafetching",
  //   link: "/pages/data-fetching",
  // },
]);
